<template lang="pug">
  div
    page_header(title="Product", subhead="Edit")
      router-link.btn.btn-primary.ml-3.d-none.d-sm-inline-block(:to='{name: "startup.products.index"}')
        i.feather-arrow-left
        | Back
    
    .row
      .col-sm-12
        form.card(@submit.prevent="submit" :class="sending?'loading':''")
          .card-body.border-bottom.p-5
            .row
              .col-sm-6
                form_input(type="text" name="name" label="Name" placeholder="Enter Product Name" v-model="form.name" :required="true")  

                .row    
                  .col-sm-6       
                    //- form_input(type="text" name="stage" label="Stage" placeholder="Enter Stage" v-model="form.stage")
                    form_select(name="stage" label="Stage" placeholder="Stage" v-model="form.stage" :options='["Beta launched", "Early revenues", "Ideation", "Proof of concept", "Steady revenues"]' :required="true")
                    
                  .col-sm-6
                    //- form_input(type="text" name="model" label="Business Model" placeholder="Enter Business Model" v-model="form.model") 
                    form_select(name="model" label="Business Model" placeholder="Business Model" v-model="form.model" :options='["B2C", "B2B", "B2G"]' :required="true")

                .row    
                  .col-sm-6 
                    //- form_input(type="text" name="sector" label="Sector" placeholder="Enter Sector" v-model="form.sector")
                    form_select(name="sector" label="Sector" placeholder="Sector" v-model="form.sector" :options="sectors" :required="true")
                  .col-sm-6
                    //- form_input(type="text" name="subsector" label="Sub Sector" placeholder="Enter Sub Sector" v-model="form.subsector")
                    form_select(name="sector" label="Sub Sector" placeholder="Sub Sector" v-model="form.subsector" :options="sub_sectors" :required="true")
                
                form_input(type="text" name="deck" label="Deck URL" placeholder="Enter Deck URL" v-model="form.deck" )
                form_input(type="url" name="video" label="Youtube Video URL" placeholder="Enter Youtube Video URL" v-model="form.video" :required="true")
                form_input(type="url" name="website" label="Website" placeholder="Enter Website" v-model="form.website" :required="true")
                //- form_input(type="text" name="traction" label="Traction" placeholder="Current Traction" v-model="form.traction" :required="true")
                .row
                  .col-sm-6
                    form_input(type="number" name="traction" label="Revenue (INR)" placeholder="Current Revenue (INR)" v-model="form.traction" :required="true")
                  .col-sm-6
                    form_input(type="number" name="investment" label="Investment Raised (INR)" placeholder="Investment Raised(INR)" v-model="form.investment" :required="true")

                
                .mb-3
                  label.form-label Use Case
                  textarea.form-control(name="usecase" rows="6" placeholder="Use Case" v-model="form.usecase" :required="true")

              .col-sm-6      
                                
                //image
                .mb-3
                  label.form-label Select Image
                  imageSelect(v-model="form.image" :h="375" :w="600" modal_class="modal-full-width" name="select-image" :required="true")
            
                .mb-3
                  label.form-label Select Cover
                  imageSelect(v-model="form.cover" :h="600" :w="1200" modal_class="modal-full-width" name="select-cover" :required="true")
              
                //- .row
                //-   .col-sm-6
                //-     form_select(name="startup" label="Startup" placeholder="Startup" v-model="form.startup" :options="startups" :item="{value:'id', label:'name'}" :required="true")
                //-   .col-sm-6
                //-     form_select(name="status" label="status" placeholder="status" v-model="form.status" :options="['active','inactive']" :required="true")

            .row
              .col-sm-12
                .mb-3
                  label.form-label Product Description
                  summernote#summernote(ref="summernote" name="summernote" :html="form.brief" :airmode="false")

            .d-flex.align-items-center
              //- a.btn.btn-link Back
              loadingBtn.ml-auto(type="submit" :disabled='sending') Save

  
      

</template>

<script>
// @ is an alias to /src

import page_header from '@/components/pageHeader'
import form_input from '@/components/formInput'
import loadingBtn from '@/components/loadingBtn'
import form_select from '@/components/formSelect'
import imageSelect from '@/components/imageSelect'
import summernote from '@/components/summernote';
import { mapActions, mapState } from 'vuex'
export default {
  name: 'Products',
  props: ['id'],
  components: {
    page_header: page_header,
    form_input,
    form_select,
    loadingBtn,
    imageSelect,
    summernote
  },
  data(){
    return {
      sector_data: [],
      startups: [],
      form: {
        sector: ''
      }
    }
  },
  computed: {
    sectors(){
      var sectors = this.sector_data.map((item)=> {
        return item.name;
      });
      return [...new Set(sectors)]
    },
    sub_sectors(){
      var sector = this.form.sector;
      // console.log(sector);
      return this.sector_data.filter((value, index, array)=>{
        // console.log(sector, value);
        return value.name == sector;
      }).map((item)=> {
        return item.sub;
      });
    },
    ...mapState('api', ['errors', 'sending'])
  },
  methods:{
    submit(){
      var vm = this;
      vm.form.brief = this.$refs.summernote.getVal();
      this.call({_vm:this, endpoint: 'startups/products/'+this.id, method: 'PUT', data: this.form})
    },
    ...mapActions('api', ['call'])
  },
  mounted(){
    var vm = this;
    this.call({_vm: vm, endpoint: `startups/products/${this.id}/edit`, method: 'GET'}).then(async (response)=>{
      vm.sector_data = response.sectors;
      vm.startups = response.startups;

      // vm.$nextTick(()=>{
        await vm.$nextTick();
        vm.form = {
          name: response.data.name,
          stage: response.data.stage,
          video: response.data.video,
          website: response.data.website,
          model: response.data.model,
          subsector: '',//response.data.subsector,
          sector: response.data.sector,
          brief: '', //response.data.brief,
          deck: response.data.deck,
          image: response.data.image,
          cover: response.data.cover,
          traction: response.data.revenue,
          investment: response.data.investment,
          usecase: response.data.usecase,
          status: response.data.status,
          startup: response.data.startup_id,
        };
        await vm.$nextTick();
        vm.form.subsector = response.data.subsector;
        vm.form.brief = response.data.brief;
        vm.$refs.summernote.setVal(response.data.brief);
      // })

    })
  }
}
</script>
